<template>
  <div :class="type" class="payment-method">
    <div class="payment-head">
      <div class="payment-method-title">
        {{ $t('payment.paymentMethod.title') }}
      </div>
      <div class="icon-wrapper">
        <div class="user-arrow"></div>
        <div class="icon-question"></div>
      </div>
    </div>
    <div class="payment-method-list">
      <div 
        class="payment-method-item" 
        :class="{'active': modelValue === item.id}" 
        v-for="item in showingPaymentMethods" 
        :key="item.id" 
        @click="selectPaymentMethod(item)"
      >
        <div class="icon">
          <img :src="item.icon" alt="icon">
        </div>
        <div class="name">
          {{ item.name }}
        </div>
        <div v-if="item.recommendFlag === 2" class="recommend-tag">{{ $t('payment.paymentMethod.recommend') }}</div>
      </div>
    </div>
    <div v-if="paymentMethods.length > 6" class="more-payment-method" @click="toggleMoreMethods">
      {{ $t('payment.paymentMethod.moreMethod') }}
      <i class="arrow-down" :class="{'up': showMore}"></i>
    </div>
    
    <div class="dianka-tip" v-if="!isShowProduct">
      <p class="dianka-tip-1">{{ $t('payment.paymentMethod.diankaTip1') }}</p>
      <p class="dianka-tip-2">{{ $t('payment.paymentMethod.diankaTip2') }}</p>
      <button class="go-pay-btn btn" @click="$emit('confirm')">
        {{ $t('payment.paymentMethod.confirm') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { isMobile } from '@/utils'
import { computed, ref, defineProps, defineEmits } from 'vue'
const type = isMobile ? 'mobile' : 'pc'

const props = defineProps({
  paymentMethods: {
    type: Array,
    default: () => []
  },
  modelValue: {
    type: [String, Number],
    default: null
  },
  isShowProduct: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'change', 'confirm'])

const showMore = ref(false)

const showingPaymentMethods = computed(() => {
  return showMore.value ? props.paymentMethods : props.paymentMethods.slice(0, 6)
})

const selectPaymentMethod = (method) => {
  if (props.modelValue === method.id) {
    return
  }
  emit('update:modelValue', method.id);
  emit('change', method);
}

const toggleMoreMethods = () => {
  showMore.value = !showMore.value;
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
